/* eslint-disable no-useless-escape */
import React from 'react';
import { ErrorMenssage } from './styles';
import { Button, Col, Form, Input, Row, notification } from 'antd';
import SelectCidade from '../SelectCidade';
import { cnpjValidation, cpfValidation } from '../../utils/validator';
import api from '../../service/api';
import { SKW_PREFIX } from '../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import Swal from 'sweetalert2';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../store/ducks/tomadoresTransportadora/actions';

export interface Props {
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setNomeTomador: React.Dispatch<React.SetStateAction<string>>;
  setSelectedTomadorOrdemCarga: React.Dispatch<any>;
}

const CadastrarParceiro: React.FC<Props> = ({
  setIsModalVisible,
  setNomeTomador,
  setSelectedTomadorOrdemCarga,
}) => {
  const dispatch = useDispatch<React.Dispatch<Action>>();
  const [form] = Form.useForm();
  const [cidade, setCidade] = React.useState<any>();
  const [loading, setLoading] = React.useState(false);
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);

  const openNotification = (msg: string, dica: string) => {
    notification.error({
      message: msg,
      description: dica,
      placement: 'bottomRight',
    });
  };

  const onFinish = (value: any) => {
    const promessa = new Promise((resolve, reject) => {
      if (value.cnpj.replace(/\.|\-|\//g, '').length === 14) {
        return cnpjValidation(value.cnpj)
          ? resolve(true)
          : reject(openNotification('CNPJ inválido', 'Verifique o CNPJ informado'));
      } else if (value.cnpj.replace(/\.|\-|\//g, '').length === 11) {
        return cpfValidation(value.cnpj)
          ? resolve(true)
          : reject(openNotification('CPF inválido', 'Verifique o CPF informado'));
      } else {
        reject(
          openNotification('CNPJ/CPF inválido', 'Verifique a quantidade de dígitos informados')
        );
      }
    });

    promessa
      .then((res) => {
        setLoading(true);
        api
          .post(`call?serviceName=${SKW_PREFIX}criaParceiro&token=${token}`, {
            parceiro: {
              nome: value?.nome,
              cnpjCpf: value?.cnpj?.replace(/[^\d]+/g, ''),
              inscricaoEstadual: value?.inscricaoEstadual,
              codCidade: +cidade?.key,
            },
            inscricoesEstaduais: inscricaoAtiva,
          })
          .then((res) => {
            setSelectedTomadorOrdemCarga(res.data?.parceiro?.codParc);
            setNomeTomador(res.data?.parceiro?.nome);
            Swal.fire({
              title: 'Parceiro cadastrado com sucesso!',
              text: '',
              icon: 'success',
              showConfirmButton: true,
              timer: 2000,
            });
            dispatch(loadRequest(inscricaoAtiva));
            setIsModalVisible && setIsModalVisible(false);
            form.resetFields();
            setLoading(false);
          })
          .catch((err) => {
            if (err.response.data.Erro) {
              Swal.fire({
                title: err.response.data.Erro,
                text: '',
                icon: 'error',
                showConfirmButton: true,
              });

            } else {
              Swal.fire({
                title: 'Erro ao tentar cadastrar parceiro!',
                text: '',
                icon: 'error',
                showConfirmButton: true,
              });
            }
            setLoading(false);
          });
      })
      .catch((err) => {
        return err;
      });
  };

  return (
    <Form layout="vertical" onFinish={onFinish} form={form}>
      <Row gutter={24}>
        <Col md={12} sm={24} xs={12}>
          <Form.Item
            id="cnpj"
            label="CNPJ/CPF:"
            name="cnpj"
            rules={[{ required: true, message: <ErrorMenssage>Digite o CNPJ/CPF</ErrorMenssage> }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col md={12} sm={24} xs={12}>
          <Form.Item
            label="Razão Social:"
            name="nome"
            rules={[
              { required: true, message: <ErrorMenssage>Digite a Razão Social</ErrorMenssage> },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col md={12} sm={24} xs={12}>
          <Form.Item
            id="inscricaoEstadual"
            label="Inscrição Estadual:"
            name="inscricaoEstadual"
            rules={[
              {
                required: true,
                message: <ErrorMenssage>Digite a Inscrição Estadual</ErrorMenssage>,
              },
            ]}
          >
            <Input onChange={(e) => (e.target.style.borderColor = '#ddd')} />
          </Form.Item>
        </Col>
        <Col md={12} sm={24} xs={12}>
          <SelectCidade label={'Cidade - UF'} setProps={setCidade} required={true} />
        </Col>
      </Row>

      <Row gutter={24}>
        <Col md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
          <Button htmlType="submit" type="primary" loading={loading}>
            OK
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default CadastrarParceiro;
